import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert'; // Import

export const ENV_MODES = {
    production:"production",
    development:"development"
}

export const ENV_MODE = ENV_MODES.production

export const DEV_BASE_URL = 'http://localhost:3333'
export const PROD_BASE_URL = 'https://api.thesportsarena.xyz'

export const BASE_URL = ENV_MODE == ENV_MODES.production ? PROD_BASE_URL : DEV_BASE_URL

export const AllBookingStatus = ["pending", "confirmed", "completed", "userCancelled", 'adminCancelled']
export const AllPaymentStatus = ["pending", "advancePaid", "success", "cancel", "failed"]

export function SetLocalItem (key, value) {

    localStorage.setItem(key, JSON.stringify(value));

}

export async function GetLocalItem (key) {

    const item = localStorage.getItem(key)

    if(item){
        return JSON.parse(item)
    }

    return false


}

export async function RemoveLocalItem (key, value) {
    localStorage.removeItem(key)
}

export async function ShowConfirm(onConfirm, onCancel, title, message){
    confirmAlert({
        title: title || 'Confirm to submit',
        message: message || 'Are you sure to do this.',
        buttons: [
            {
                label: 'Yes',
                onClick: onConfirm
            },
            {
                label: 'No',
                onClick: onCancel
            }
        ]
    });
}

export function RemoveEmptyDataFromObj(obj) {
    return Object.entries(obj)
      .filter(([_, v]) => v != null)
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
  }

export  function GetCurrentMonthDates() {
    const currentDate = moment();
    const numberOfDays = currentDate.daysInMonth();
    const dates = [];
  
    for (let i = 1; i <= numberOfDays; i++) {
      const date = currentDate.date(i);
      dates.push(date.toISOString());
    }
  
    return dates;
}


export function GetISOStringsForDay() {
    const dayStart = new Date(); // Current date and time
  dayStart.setHours(6, 0, 0, 0); // Set time to 6:00 AM

  const intervals = [];
  const intervalInMinutes = 90; // 1.5 hours in minutes

  const hoursInDay = 21 - 6; // From 6:00 AM to 3:00 AM next day
  const totalIntervals = hoursInDay * 60 / intervalInMinutes;

  for (let i = 0; i < totalIntervals; i++) {
    const newTime = new Date(dayStart.getTime() + i * intervalInMinutes * 60000);
    intervals.push(newTime.toISOString());
  }

  return intervals;
  }


export const Slots = [
    { start: '00:00', end:"01:29", label: '12:00 AM - 01:30 AM' },
    { start: '01:30', end:"02:59", label: '01:30 AM - 03:00 AM' },
    { start: '06:00', end:"07:29", label: '06:00 AM - 07:30 AM' },
    { start: '07:30', end:"08:59", label: '07:30 AM - 09:00 AM' },
    { start: '09:00', end:"10:29", label: '09:00 AM - 10:30 AM' },
    { start: '10:30', end:"11:59", label: '10:30 AM - 12:00 PM' },
    { start: '12:00', end:"13:29", label: '12:00 PM - 01:30 PM' },
    { start: '13:30', end:"14:59", label: '01:30 PM - 03:00 PM' },
    { start: '14:59', end:"16:29", label: '03:00 PM - 04:30 PM' },
    { start: '16:30', end:"17:59", label: '04:30 PM - 06:00 PM' },
    { start: '18:00', end:"19:29", label: '06:00 PM - 07:30 PM' },
    { start: '19:30', end:"20:59", label: '07:30 PM - 09:00 PM' },
    { start: '21:00', end:"22:29", label: '09:00 PM - 10:30 PM' },
    { start: '22:30', end:"23:59", label: '10:30 PM - 12:00 AM' },
]

export const OneHourSlots = [
    { start: '00:00', end: '00:59', label: '12:00 AM - 01:00 AM' },
    { start: '01:00', end: '01:59', label: '01:00 AM - 02:00 AM' },
    { start: '02:00', end: '02:59', label: '02:00 AM - 03:00 AM' },
    { start: '06:00', end: '06:59', label: '06:00 AM - 07:00 AM' },
    { start: '07:00', end: '07:59', label: '07:00 AM - 08:00 AM' },
    { start: '08:00', end: '08:59', label: '08:00 AM - 09:00 AM' },
    { start: '09:00', end: '09:59', label: '09:00 AM - 10:00 AM' },
    { start: '10:00', end: '10:59', label: '10:00 AM - 11:00 AM' },
    { start: '11:00', end: '11:59', label: '11:00 AM - 12:00 PM' },
    { start: '12:00', end: '12:59', label: '12:00 PM - 01:00 PM' },
    { start: '13:00', end: '13:59', label: '01:00 PM - 02:00 PM' },
    { start: '14:00', end: '14:59', label: '02:00 PM - 03:00 PM' },
    { start: '15:00', end: '15:59', label: '03:00 PM - 04:00 PM' },
    { start: '16:00', end: '16:59', label: '04:00 PM - 05:00 PM' },
    { start: '17:00', end: '17:59', label: '05:00 PM - 06:00 PM' },
    { start: '18:00', end: '18:59', label: '06:00 PM - 07:00 PM' },
    { start: '19:00', end: '19:59', label: '07:00 PM - 08:00 PM' },
    { start: '20:00', end: '20:59', label: '08:00 PM - 09:00 PM' },
    { start: '21:00', end: '21:59', label: '09:00 PM - 10:00 PM' },
    { start: '22:00', end: '22:59', label: '10:00 PM - 11:00 PM' },
    { start: '23:00', end: '23:59', label: '11:00 PM - 12:00 AM' },
];